import axios from "axios";
import { toast } from "sonner";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("eco_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (resp) => resp,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    const isAuthProbe = url.includes("/auth/login") || url.includes("/auth/register");
    if (status === 401 && !isAuthProbe) {
      const hadToken = !!localStorage.getItem("eco_token");
      clearAuth();
      if (hadToken && window.location.pathname !== "/login") {
        toast.error("Your session expired — please sign in again");
        setTimeout(() => { window.location.href = "/login"; }, 800);
      }
    }
    return Promise.reject(err);
  }
);

export const saveAuth = (token, user) => {
  localStorage.setItem("eco_token", token);
  localStorage.setItem("eco_user", JSON.stringify(user));
};

export const clearAuth = () => {
  localStorage.removeItem("eco_token");
  localStorage.removeItem("eco_user");
};

export const getUser = () => {
  try {
    const raw = localStorage.getItem("eco_user");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};
